import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { useMemo } from 'react';
import { useTheme } from '@mui/material';
import cs from 'classnames';
import { useVisibleContext } from './context';
/**
 * A media query that combines both CSS & JS to provide:
 *   - SSR support
 *   - No flash of changing markup on initial load
 *   - No continuous rendering of two versions of the DOM
 */
export function Visible(props) {
    const { above, below, display = 'block', className, ...rest } = props;
    const { isMdAndUp, isLgAndUp, isXlAndUp } = useVisibleContext();
    const theme = useTheme();
    if (process.env.NODE_ENV === 'development') {
        if ((!above && !below) || (above && below))
            throw new Error('<Visible> must be passed either the "above" prop OR the "below" prop, but not both. Both may be supported in the future.');
    }
    const shouldRender = useMemo(() => {
        const mapping = { md: isMdAndUp, lg: isLgAndUp, xl: isXlAndUp };
        if (above)
            return mapping[above];
        if (below)
            return !mapping[below];
        return null;
    }, [isMdAndUp, isLgAndUp, isXlAndUp, above, below]);
    const isVisibleQueryLoading = shouldRender == null;
    const hideViaCss = above
        ? {
            display: 'none',
            [theme.breakpoints.up(above)]: {
                display,
            },
        }
        : {
            [theme.breakpoints.up(below)]: {
                display: 'none',
            },
        };
    if (!isVisibleQueryLoading && !shouldRender)
        return null;
    return _jsx("div", { ...rest, css: hideViaCss, className: cs('Visible', className) });
}
Visible.defaultProps = {
    display: 'block',
};
